import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Trophy, Flame, Share2, Star } from "lucide-react";
import { sharePotwImage } from "../lib/shareBadge";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SAMPLE = { name: "Marcus R.", streak: 21, points: 2450 };

export default function PlayerOfWeek({ sampleFallback = false }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/player-of-the-week`).then(({ data }) => setData(data)).catch(() => setData({ player: null }));
  }, []);

  const player = data?.player || (sampleFallback ? SAMPLE : null);
  const isSample = !data?.player && sampleFallback;

  if (data && !data.player && !sampleFallback) {
    return (
      <div data-testid="potw-empty" className="bg-[#141414] border border-white/10 rounded-xl p-5 text-center">
        <Trophy size={22} className="text-[#F5C518] mx-auto mb-2" />
        <p className="text-sm text-white/60">No Player of the Week yet — start a streak to claim the crown! 🏆</p>
      </div>
    );
  }
  if (!player) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      data-testid="player-of-the-week"
      className="relative overflow-hidden rounded-2xl border border-[#F5C518]/40 bg-gradient-to-br from-[#1a1508] to-[#141414] p-6"
    >
      <div className="absolute -right-6 -top-6 opacity-10"><Trophy size={140} className="text-[#F5C518]" /></div>
      <div className="relative">
        <div className="flex items-center gap-2 mb-4">
          <Star size={14} className="text-[#F5C518] fill-[#F5C518]" />
          <span className="font-subheadings text-xs font-bold uppercase tracking-[0.25em] text-[#F5C518]">Player of the Week</span>
        </div>
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-[#F5C518]/15 border-2 border-[#F5C518] flex items-center justify-center flex-shrink-0">
            <span className="font-cover text-3xl text-[#F5C518]">{(player.name || "?")[0].toUpperCase()}</span>
          </div>
          <div className="min-w-0">
            <div className="font-headings text-2xl uppercase tracking-wide truncate">{player.name}</div>
            <div className="flex items-center gap-1.5 text-sm text-white/70 mt-1">
              <Flame size={15} className="text-[#C41E24]" />
              <span className="font-bold text-[#C41E24]">{player.streak}-day streak</span>
              {player.points != null && <span className="text-white/40">· {player.points.toLocaleString()} pts</span>}
            </div>
          </div>
        </div>
        <button
          data-testid="potw-share"
          onClick={() => sharePotwImage(player.name, player.streak)}
          className="mt-5 inline-flex items-center gap-2 bg-[#F5C518] hover:bg-[#e0b400] text-black font-subheadings font-bold uppercase tracking-wider text-xs px-4 py-2.5 rounded-sm transition-colors"
        >
          <Share2 size={14} /> Share Shout-Out
        </button>
        {isSample && <p className="text-[10px] text-white/35 mt-3 uppercase tracking-wider">Sample — your top player features here once streaks begin</p>}
      </div>
    </motion.div>
  );
}
